module.exports = __webpack_public_path__ + "img/KeyPal-Plus.41668966.png";